<template>
  <div class="m-the-header-sub-menu">
    <ul class="m-the-header-sub-menu-list">
      <li>
        <a
          class="a-tooltip-primary a-tooltip-bottom"
          data-tooltip-text="Notificaciones"
          href="#"
          @click.prevent=""
        >
          <i class="far fa-bell text-color-billing-primary"></i>
        </a>
      </li>
      <li>
        <div class="m-dropdown-primary">
          <AtomAvatarPrimary
            :avatar-primary="avatarPrimary"
            @switchDropDowns="switchDropDowns"
          />
          <MoleculeTheHeaderSubMenuDropDownUser/>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'MoleculeTheHeaderSubmenu',

  components: {
    MoleculeTheHeaderSubMenuDropDownUser: () => import('@/components/molecules/MoleculeTheHeaderSubMenuDropDownUser')
  },

  data () {
    return {
      avatarPrimary: {
        component: '',
        image: '',
        method: 'switchDropDowns'
      },

      showLoadingState: false
    }
  },

  created () {
    this.avatarPrimary.image = this.$store.getters.getUserData.vidroop_data.avatar
  },

  methods: {
    switchDropDowns () {
      this.$dropDown.switchDropDown('MoleculeTheHeaderSubMenuDropDownUser')
    }
  }
}
</script>
